/**
 * Khối pháp nhân "BÊN B" của hợp đồng — mã số thuế, giấy chứng nhận đăng ký, người
 * đại diện ký, tài khoản ngân hàng.
 *
 * NGUỒN DUY NHẤT về key + nhãn tiếng Việt cho HAI form dùng chung khối này:
 *   • Khách hàng thuê bao (App.jsx → CustomerModal)
 *   • Khách hàng của từng thiết bị (DeviceModal.jsx → TabOwner), khi Bên B là doanh
 *     nghiệp / hộ kinh doanh
 *
 * Key khớp đúng cột DB + JSON của backend (cmd/mdmquery/party.go). Mỗi form tự vẽ ô
 * nhập bằng wrapper của mình (.uform label · <Fld>) nên ở đây chỉ mô tả field.
 */

// Tư cách ký — đúng 3 ô tick trên mẫu hợp đồng giấy.
export const CAPACITY_OPTIONS = [
  { value: '', label: '— Chưa xác định —' },
  { value: 'legal', label: 'Người đại diện theo pháp luật' },
  { value: 'household', label: 'Chủ hộ kinh doanh' },
  { value: 'authorized', label: 'Người được uỷ quyền' },
];

// Nhóm field -> tiêu đề nhỏ trong form (theo đúng các mục của hợp đồng).
export const LEGAL_GROUPS = [
  { key: 'reg', title: 'Giấy chứng nhận đăng ký' },
  { key: 'rep', title: 'Người đại diện ký hợp đồng' },
  { key: 'bank', title: 'Tài khoản ngân hàng' },
];

// poaOnly: chỉ hiện khi tư cách ký = "Người được uỷ quyền".
export const LEGAL_FIELDS = [
  { k: 'tax_code', group: 'reg', label: 'Mã số thuế', placeholder: '0316123456' },
  { k: 'reg_no', group: 'reg', label: 'Số giấy chứng nhận' },
  { k: 'reg_issuer', group: 'reg', label: 'Do cơ quan cấp', full: true, placeholder: 'Sở KH&ĐT TP.HCM / UBND Quận…' },
  { k: 'reg_date', group: 'reg', label: 'Cấp ngày', type: 'date' },
  { k: 'rep_name', group: 'rep', label: 'Ông/Bà', placeholder: 'Nguyễn Văn A' },
  { k: 'rep_title', group: 'rep', label: 'Chức vụ', placeholder: 'Giám đốc' },
  { k: 'rep_id_no', group: 'rep', label: 'Số định danh cá nhân' },
  { k: 'rep_id_date', group: 'rep', label: 'Cấp ngày', type: 'date' },
  { k: 'rep_capacity', group: 'rep', label: 'Tư cách ký', type: 'select', options: CAPACITY_OPTIONS, full: true },
  { k: 'rep_poa_no', group: 'rep', label: 'Giấy uỷ quyền số', poaOnly: true },
  { k: 'rep_poa_date', group: 'rep', label: 'Giấy uỷ quyền ngày', type: 'date', poaOnly: true },
  { k: 'bank_account', group: 'bank', label: 'Tài khoản số' },
  { k: 'bank_name', group: 'bank', label: 'Tại ngân hàng', placeholder: 'Vietcombank — CN…' },
  { k: 'bank_holder', group: 'bank', label: 'Chủ tài khoản', full: true },
];

export const LEGAL_KEYS = LEGAL_FIELDS.map(f => f.k);

// Field của một nhóm, đã lọc bỏ ô giấy uỷ quyền khi không ký theo uỷ quyền.
export const legalGroupFields = (group, capacity) =>
  LEGAL_FIELDS.filter(f => f.group === group && (!f.poaOnly || capacity === 'authorized'));

// legalForm: lấy giá trị khởi tạo từ bản ghi server (null/undefined -> chuỗi rỗng).
export function legalForm(src) {
  const f = {};
  LEGAL_KEYS.forEach(k => { f[k] = (src && src[k] != null) ? String(src[k]) : ''; });
  return f;
}

// legalPayload: phần thân gửi lên server. Ký theo uỷ quyền mới gửi số/ngày giấy uỷ
// quyền — đổi tư cách ký xong là dữ liệu uỷ quyền cũ được dọn luôn.
export function legalPayload(f) {
  const out = {};
  LEGAL_KEYS.forEach(k => { out[k] = String(f[k] ?? '').trim(); });
  if (out.rep_capacity !== 'authorized') { out.rep_poa_no = ''; out.rep_poa_date = ''; }
  return out;
}

// Kiểm tra phía client, khớp normalize() của party.go — để người nhập thấy lỗi ngay.
export function legalMissing(f) {
  const miss = [];
  if (String(f.rep_capacity ?? '') === 'authorized' && !String(f.rep_poa_no ?? '').trim()) {
    miss.push('Giấy uỷ quyền số');
  }
  return miss;
}
